import script from "./AudioWaveform.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioWaveform.vue?vue&type=script&setup=true&lang=js"

import "./AudioWaveform.vue?vue&type=style&index=0&id=f5092ee6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5092ee6"]])

export default __exports__